import React from 'react';
import { Card, CardProps } from 'react-bootstrap';

export type GenericCardVariant = 'gray' | 'white' | 'transperant' | 'red';

export type customGenericCardsProps = CardProps &
  React.PropsWithChildren<{
    variant?: GenericCardVariant;
    className?: string;
    withShadow?: boolean;
  }>;

const GenericCard = ({
  variant = 'gray',
  children,
  className,
  withShadow = true,
  ...props
}: customGenericCardsProps) => {
  return (
    <Card
      bg={variant}
      bsPrefix={'custom-generic-card'}
      className={withShadow ? '' : ' shadow-none'}
      {...props}
    >
      <Card.Body className={className}>{children}</Card.Body>
    </Card>
  );
};

export default GenericCard;
